import {
  SELECTED_VERSION,
  API_REQUEST_SUCCESS,
  API_REQUEST_FAILURE,
  RESET_SELECT_OPTIONS,
  FORM_IS_DIRTY,
  RESET_SELECT_VERSIONS,
} from '../actions';

let years = [
  { value: '0', label: '2023/2024' },
  { value: '1', label: '2024/2025' },
  { value: '2', label: '2025/2026' },
];
const currentDate = new Date();
const aprilFirst2024 = new Date('2024-04-01');

// Remove old year data after april 2024
if (currentDate > aprilFirst2024) {
  years = [
    { value: '0', label: '2024/2025' },
    { value: '1', label: '2025/2026' },
  ];
}

export const initialState = {
  make: [],
  model: [],
  version: [],
  year: years,
  results: [],
  bodyStyles: [],
  selectedVersion: {},
  formIsDirty: false,
};

export default (state, action) => {
  switch (action.type) {
    case API_REQUEST_SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case API_REQUEST_FAILURE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case FORM_IS_DIRTY: {
      return {
        ...state,
        formIsDirty: action.payload,
      };
    }
    case RESET_SELECT_OPTIONS: {
      return {
        ...initialState,
        make: state.make,
      };
    }
    case RESET_SELECT_VERSIONS: {
      return {
        ...state,
        version: [],
      };
    }
    case SELECTED_VERSION: {
      return {
        ...state,
        selectedVersion: action.payload,
      };
    }
    default:
      return state;
  }
};
